import { HttpClient } from '@angular/common/http';
import { ChatMessage, ChatSession } from '../interfaces/chat.interface';
import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ChatService {
  constructor(private httpService: HttpClient) {}

  getChatSessionBySessionId(session_id: string) {
    return this.httpService.get<ChatSession>(
      environment.api_host + `sessions/${session_id}/chat-sessions`,
    );
  }

  createChatSession(session_id: string, user_id?: string) {
    const params = user_id ? { params: { user_id } } : {};
    return this.httpService.post<ChatSession>(
      environment.api_host + `sessions/${session_id}/chat-sessions`,
      {},
      params,
    );
  }

  sendMessage(message: ChatMessage, connection_id: string, sessionId: string) {
    return this.httpService.post(
      environment.api_host +
        `sessions/${sessionId}/chat-sessions/${message.chat_session_id}/chat-messages`,
      {
        message: message.message,
        sender: message.sender,
        connection_id: connection_id,
        user_id: message.user_id,
      },
    );
  }

  // removeMessage(chat_message_id: string) {
  //   return this.httpService.delete(
  //     'https://api.example.com/chat/' + chat_message_id,
  //   );
  // }
}
